import React from "react";

import Styled from "./TotalCostStyles";

import moment from 'moment'
import { Color, ColorSAP, FONT_FAMILY, Typography } from "../../ontego-ui";
import { formatNumericalWithThousandSeparator } from "../../Utils/Utils";
import Button from "../Button/Button";

export const TotalCost = (props) => {
    const { id, totalCost = {
        price: 1470,
        textBilledDate: "31 January 2019"
    }, actionHandler, textTotalCostThisMonth = 'Total Cost This Month', textGoToBilling = 'Go to Billing', style, textBilledOn = 'Billed on' } = props

    return (
        <Styled.TotalCostContainer
            id={`${id}-total-cost-container`}
            style={style}
        >
            <Typography
                fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                size={24}
                color={ColorSAP.neutral[0]}
            >
                {textTotalCostThisMonth}
            </Typography>
            <Styled.TotalCost
                id={`${id}-total-cost`}
                style={{ marginTop: 73 }}
            >
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                    size={56}
                    color={Color.neutral[0]}
                >
                    {`${formatNumericalWithThousandSeparator(totalCost?.price ?? 0)} €`}
                </Typography>
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR_ITALIC}
                    size={12}
                    color={Color.neutral[0]}
                    style={{ marginTop: 12 }}
                >
                    {totalCost?.textBilledDate ? textBilledOn + ` ${moment(totalCost?.textBilledDate).format("DD MMMM YYYY")}` : `No billing data yet!`}
                </Typography>
            </Styled.TotalCost>
            {actionHandler &&
                <Button
                    id={`${id}-total-price-box-button`}
                    type="secondary"
                    color="white"
                    alignIcon="right"
                    style={{ marginTop: 20 }}
                    onClick={actionHandler}
                >
                    {textGoToBilling}
                </Button>
            }
        </Styled.TotalCostContainer>
    );
}

export default React.memo(TotalCost)